import CoachingNote from "@app/scene/dashboard/types/CoachingNote";

// Silent-poll reconcile. `fresh` is the server's current state of the re-synced
// window, so it already carries creates, edits AND deletes — we take it as the
// source of truth. A union-merge can only add, never drop, so it could never
// reflect a delete; reconciling against `fresh` does. The only loaded rows we
// keep that `fresh` omits are:
//   - optimistic temps (negative id, still mid-save — create/reply success will
//     swap them in), and
//   - when more rows exist than we re-synced (`hasMore`, the notes feed only),
//     rows that sort below the window floor: newer rows merely bumped them past
//     the re-synced window, so keep them as the tail to hold scroll. `fresh` is
//     -updatedAt DESC, so its last row's updatedAt is that floor; a missing row
//     at/above it was deleted, not bumped, so it correctly drops out.
// Reply re-syncs pass hasMore=false (their window covers all loaded), so the
// floor logic is skipped and the createdAt-ASC ordering doesn't apply here.
const reconcileLiveList = (
  fresh: CoachingNote[],
  loaded: CoachingNote[],
  hasMore: boolean
): CoachingNote[] => {
  const freshIds = new Set(fresh.map((note) => note.id));
  const windowFloor = hasMore && fresh.length > 0 ? fresh[fresh.length - 1].updatedAt : undefined;
  const kept = loaded.filter(
    (note) =>
      !freshIds.has(note.id) &&
      (note.id < 0 || (windowFloor !== undefined && note.updatedAt < windowFloor))
  );
  return [...fresh, ...kept];
};

export default reconcileLiveList;
